import { useEffect, useState } from "react"
import { api, urls } from '../../../services/api'
import { Item } from "./components/Item"
import { IMenu } from '../../../types/listItems'
import { ChevronDown, LayoutGrid } from 'lucide-react'
import { SectionTitle } from "../../ui/SectionTitle"

import { Section } from "../../ui/Section"

export function ServicesAccordion() {
	const [listMenu, setListMenu] = useState<IMenu[]>([])

	useEffect(() => {
		(async () => {
			const response = await api.get(urls.Services)
			setListMenu(response.data)
		})()
	}, [])

	return (
		<Section className="bg-white dark:bg-surface-dark transition-colors" aria-label="Serviços">
			<SectionTitle title="Serviços Online" icon={<LayoutGrid size={24} className="text-secondary" />} />

			<div className="w-full flex flex-col shadow-xl dark:shadow-premium-dark rounded-3xl overflow-hidden border border-border-default dark:border-border-default-dark">

				<div className="flex flex-col bg-surface-alt/30 dark:bg-surface-dark-alt">
					{listMenu.map((item, index) => (
						<details
							key={index}
							className="group border-b border-border-default/50 dark:border-border-default-dark/50"
							open={index === 0}
						>
							<summary className="font-bold cursor-pointer text-primary dark:text-on-surface-dark bg-secondary/10 dark:bg-white/5 group-open:bg-secondary/20 dark:group-open:bg-white/10 text-sm p-5 uppercase select-none outline-none list-none flex justify-between items-center transition-all">
								{item.menu}
								<ChevronDown size={18} className="transform group-open:rotate-180 transition-transform" />
							</summary>
							<div className="bg-white dark:bg-surface-dark p-4 transition-colors">
								<ul className="m-0 p-0 list-none space-y-3">
									{item.servicos.map((service, idx) => (
										<Item
											key={idx}
											titulo={service.titulo}
											cod_servico={service.cod_servico}
										/>
									))}
								</ul>
							</div>
						</details>
					))}
				</div>

				<a
					href="https://servicos.itajai.sc.gov.br/"
					className="w-full h-16 flex items-center justify-center bg-secondary text-primary font-bold text-sm uppercase tracking-widest no-underline hover:bg-secondary-dark transition-colors"
				>
					Veja todos os serviços
				</a>
			</div>
		</Section>
	)
}